'use client';

import type { GetCurationsServiceResponse, VisitorCurationItem } from '@musinsa/services-curator';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { curatorQueries } from '../../query-factory';

interface Props {
  snsTitle: string;
  curationId?: string;
  size?: number;
  type?: 'GOODS' | 'SNAP2';
}

export const useVisitorCurationsInfiniteQuery = ({
  snsTitle,
  curationId,
  size = 5,
  type,
}: Props) => {
  const query = useInfiniteQuery({
    ...curatorQueries.curations.list({ snsTitle, curationId, size, type }),
    initialPageParam: 1,
    getNextPageParam: (lastResponse: GetCurationsServiceResponse) =>
      lastResponse.pagination.hasNextPage ? lastResponse.pagination.nextPage : undefined,
  });

  const flattenedData: VisitorCurationItem[] = useMemo(
    () => query.data?.pages.flatMap((page) => page.list) ?? [],
    [query.data],
  );

  return {
    ...query,
    products: flattenedData,
  };
};
